<template>
  <div>
    <b-card-code class="mt-2 principal">
      <b-button
        id="btn-excel"
        ref="btnexcel"
        variant="primary"
        size="sm"
        style="
          margin-right: 1%;
          background: #37ef00 !important;
          border-color: #37ef00 !important;
        "
        @click="cargarUsuarios((excel_btn = '1'))"
      >
        <font-awesome-icon icon="fa-solid fa-file-excel" />
      </b-button>
      <b-button
        id="btn-pdf"
        variant="danger"
        size="sm"
        @click="cargarUsuarios((excel_btn = ''), (pdf_btn = '1'))"
      >
        <font-awesome-icon icon="fa-solid fa-file-pdf" />
      </b-button>
      <b-row class="mt-2">
        <b-col md="4">
          <b-form-group>
            <label>Nombres:</label>
            <b-form-input
              v-model="nombres"
              placeholder="Buscar por nombres"
              type="text"
              class="d-inline-block"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label>Apellidos:</label>
            <b-form-input
              v-model="apellidos"
              placeholder="Buscar por apellidos"
              type="text"
              class="d-inline-block"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label>Correo electrónico:</label>
            <b-form-input
              v-model="correo"
              placeholder="Buscar por correo electrónico"
              type="text"
              class="d-inline-block"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label>Username:</label>
            <b-form-input
              v-model="username"
              placeholder="Buscar por username"
              type="text"
              class="d-inline-block"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label>Estado:</label>
            <v-select
              id="estado"
              v-model="estado"
              :options="estados"
              :reduce="(option) => option.value"
              label="text"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" class="pb-2">
          <b-button variant="primary" size="sm" @click="filtrar">
            <font-awesome-icon icon="fa-solid fa-magnifying-glass" /> Consultar
          </b-button>
        </b-col>
      </b-row>
    </b-card-code>

    <b-overlay :show="mostrarLoader" opacity="0.50" rounded="sm">
      <b-card-code class="principal">
        <b-col cols="12" class="pr-0 pl-0 mt-2">
          <b-table
            v-if="items.length > 0"
            bordered
            striped
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <!--          <template #cell(avatar)="data">-->
            <!--            <b-avatar :src="'http://lobitozz.lobitogalapagos.com:8000/usuario/servir_imagen_perfil/' + data.item.token" />-->
            <!--          </template>-->

            <template #cell(usuario.username)="data">
              <b-link
                :to="{
                  name: 'editusuario',
                  params: { token: data.item.token },
                }"
              >
                {{ data.value }}
              </b-link>
            </template>

            <template #cell(usuario.is_active)="data">
              <b-badge :variant="is_active[1][data.value]">
                {{ is_active[0][data.value] }}
              </b-badge>
            </template>
          </b-table>

          <div v-else class="text-center">
            <p>No se encontraron registros</p>
          </div>
        </b-col>

        <b-col cols="12" class="mb-2">
          <b-pagination
            v-if="items.length > 0"
            v-model="currentPage"
            :total-rows="items.length"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0"
            align="center"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-card-code>
    </b-overlay>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCard,
  BImg,
  BCardHeader,
  BCardGroup,
  BCardTitle,
  BLink,
} from "bootstrap-vue";
import BCardCode from "@core/components/b-card-code";
import axios from "@/libs/axios";
import actions from "@/assets/utils/utils";
import vSelect from "vue-select";
import $ from "jquery";

import { BOverlay } from "bootstrap-vue";
import Vue from "vue";

export default {
  components: {
    BLink,
    BCardHeader,
    BCardGroup,
    BCardTitle,
    BCardCode,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BImg,
    vSelect,
    BOverlay,
  },
  data() {
    return {
      login_user: "",
      perPage: 10,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        // {
        //   key: 'avatar', label: 'Foto',
        // },
        {
          key: "usuario.username",
          label: "Username",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "identificacion",
          label: "Identificación",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "usuario.first_name",
          label: "Nombres",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "usuario.last_name",
          label: "Apellidos",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "usuario.email",
          label: "Correo electrónico",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "usuario.is_active",
          label: "Activo",
          sortable: true,
          thClass: "text-center",
        },
      ],
      items: [],
      is_active: [
        {
          false: "Inactivo",
          true: "Activo",
        },
        {
          false: "light-secondary",
          true: "light-success",
        },
      ],

      nombres: "",
      apellidos: "",
      correo: "",
      username: "",

      estado: "all",

      estados: [
        { value: "1", text: "Activo" },
        { value: "0", text: "Inactivo" },
        { value: "all", text: "Todos" },
      ],
      mostrarLoader: false,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  created() {
    this.comprobarPermisos();
    $("#btn-excel").remove();
    $("#btn-pdf").remove();
    $("#btn-print").remove();
    $("#eliminar-viajes").remove();
    $("#btn-abrir-caja").remove();
    this.setToken();
  },
  mounted() {
    actions.setearTitulo("");
    this.cargarUsuarios();
    $("#contenedor-botones").append($("#btn-excel")).append($("#btn-pdf"));
  },
  methods: {
    comprobarPermisos() {
      if (
        localStorage.getItem("permisos").indexOf("usu_usuario_consultar") === -1
      ) {
        this.$router.push({ name: "not-permitted" });
      }
    },
    filtrar() {
      this.cargarUsuarios();
    },
    cargarUsuarios(excel_btn = "", pdf_btn = "") {
      this.mostrarLoader = true;
      axios
        .post("api", {
          query: `query allUsers($nombres: String!, $apellidos: String!, $correo: String!, $username: String!, $estado: String!, $excel: String!, $pdf: String!){
                    allUsers(nombres: $nombres, apellidos: $apellidos, correo: $correo, username: $username, estado: $estado, excel:$excel, pdf:$pdf){
                        usuarios{
                            identificacion,
                            token,
                            avatar,
                            usuario{
                                username,
                                first_name: firstName,
                                last_name: lastName,
                                email,
                                is_active: isActive
                            }
                        },
                        dataarchivo,
                        status,
                        message
                    }
                }`,
          variables: {
            nombres: this.nombres,
            apellidos: this.apellidos,
            correo: this.correo,
            username: this.username,
            estado: this.estado,
            excel: excel_btn,
            pdf: pdf_btn,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.allUsers.status === "success") {
              if (response.data.data.allUsers.usuarios) {
                this.items = response.data.data.allUsers.usuarios;
              } else {
                var data = response.data.data.allUsers.dataarchivo;
                if (excel_btn === "1") {
                  actions.cargarArchivos(
                    data,
                    "Usuarios.xlsx",
                    "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64"
                  );
                } else {
                  actions.cargarArchivos(
                    data,
                    "Usuarios.pdf",
                    "data:application/pdf;base64"
                  );
                }
              }
            }
          }
          this.mostrarLoader = false;
        });
    },
    setToken() {
      const usuarioCookie = this.$cookie.get("usuario");
      if (usuarioCookie != null) {
        const user = JSON.parse(usuarioCookie);
        this.login_user = user.username;
        axios.defaults.headers.common.Authorization = `JWT ${user.token}`; // for all requests
      }
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    newUsuario() {
      this.$router.push({ name: "formusuario" });
    },
  },
};
</script>
<style>
.principal .card-header {
  display: none !important;
}
.principal .card-body {
  padding-bottom: 0 !important;
}
[dir] .table th,
[dir] .table td {
  padding-left: 1%;
  padding-right: 1%;
}
</style>
